<script setup>
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot, Switch } from '@headlessui/vue'
import { Link, Head, usePage, useForm } from '@inertiajs/vue3'
import { computed } from 'vue'
import { ref } from 'vue'
import { getUser } from '../../Composables/userHelper';
import Dropdown from 'primevue/dropdown';
import Calendar from 'primevue/calendar';
import { requestNotifications } from '../../Composables/notificationHelper';
import { getMessaging, getToken } from "firebase/messaging";
import { initializeApp } from "firebase/app";
import axios from 'axios';
import { isSupported } from "firebase/messaging";
import { formatDate } from '../../Composables/formatDate'
import { formatMonth } from '../../Composables/formatDate'
import moment from 'moment';

const page = usePage();

const props = defineProps({
  newLots: Array,
  lots: Array,
  users: Array
})

function formatMileage(mileage) {
    return mileage.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}

const eurFormatter = new Intl.NumberFormat('nl-NL', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 0
})

isSupported().then((isSupported) => {
  if (isSupported) {
    //try to enable fcm tokens
    var firebaseConfig = {
      apiKey: "AIzaSyCeXCC9kdXA3V24xlc_15M63_D5Pt_fQGU",
      authDomain: "mijnautosnelweg-4b4f4.firebaseapp.com",
      projectId: "mijnautosnelweg-4b4f4",
      storageBucket: "mijnautosnelweg-4b4f4.appspot.com",
      messagingSenderId: "538737820966",
      appId: "1:538737820966:web:23cdf4cf952bd2c45dede7",
      measurementId: "G-KQVNRHT4TX"
    };

    // Initialize Firebase
    const firebaseApp = initializeApp(firebaseConfig);
    requestNotifications();
    if ('serviceWorker' in navigator && navigator.serviceWorker) {
      const messaging = getMessaging(firebaseApp);
      navigator.serviceWorker.register('/firebase-messaging-sw.js').then((register) => {
        getToken(messaging, { vapidKey: 'BJ3J97IX-V4YM3AMmTNSYX_rq11jrDV27itZWr1kMbiH5e1ob4cGoygKorlb3hdIgrjWnjfpXjP2YN-CLgZyJ_I' }).then((fcmToken) => {
          //save fcm token to database
          axios.post('/portal/fcmToken', {
            fcm_token: fcmToken
          }).then((response) => {
            // console.log(response);
          }).catch((error) => {
            // console.log(error);
          });
        });
      })
    } else {
      console.log('Service Worker not supported')
    }
  }
});

const user = getUser();

const taskForm = useForm({
  name: null,
  due_date: null,
  description: null,
  notify: false,
  notify_at: null,
  lot_id: null,
  user_id: user.value.id
})

const meetings = ref(user.value.tasks);
const statsAdmin = [
  { url: "/portal/kavels", name: 'Aangemelde kavels', value: page.props.lot_count, icon: 'box-archive' },
  { url: "/portal/facturen", name: 'Afgeronde verkopen', value: page.props.orders_count, icon: 'arrow-trend-up' },
  { url: "/portal/dealers", name: 'Aangesloten dealers', value: page.props.dealer_count, icon: 'briefcase' },
]
const statsDealer = [
  { url: "/portal/favorieten", name: 'Favoriete kavels', value: page.props.favorite_count, icon: 'star' },
  { url: "/portal/facturen", name: 'Openstaande facturen', value: user.value.orders_count, icon: 'cart-shopping' },
  { url: "/portal/biedingen", name: 'Eerdere biedingen', value: user.value.bids_count, icon: 'tag' },
]

function storeTask() {
  taskForm.post('/portal/taken/aanmaken', {
    preserveScroll: true,
    onSuccess: (response) => {
      taskForm.reset()
      showTask.value = false;
      //update the task in the meetings array
      meetings.value = response.props.auth.user.tasks
    },
  })
}

function generateCalendarDays(year, month) {
  const days = [];

  // Define first day of the current month and last day of the current month
  const firstDayOfMonth = new Date(year, month, 1);
  const lastDayOfMonth = new Date(year, month + 1, 0);

  // Find out the weekday of the first and last day of the month
  const firstDayOfWeek = firstDayOfMonth.getDay();
  const lastDayOfWeek = lastDayOfMonth.getDay();

  // Calculate overflow from previous and next month
  const prevMonthOverflow = firstDayOfWeek;
  const nextMonthOverflow = 6 - lastDayOfWeek; // Assuming Sunday is the first day of the week and is represented by 0

  // Calculate dates for previous month's overflow
  const prevMonthYear = month === 0 ? year - 1 : year;
  const prevMonth = month === 0 ? 11 : month - 1;
  const totalDaysPrevMonth = new Date(prevMonthYear, prevMonth + 1, 0).getDate();

  // Function to add day objects to the days array
  const addDay = (date, isCurrentMonth) => {
    const dateKey = formatDate(date);
    const isToday = date.toDateString() === new Date().toDateString();


    const day = {
      date: date,
      dateKey: dateKey,
      isCurrentMonth,
      isToday: isToday,
      // events: daysToEventsMap[dateKey] || [],
    };
    if (isToday) {
      selectedDate.value = day.date;
    }
    days.push(day);
  };

  // Add days from the previous month
  for (let i = prevMonthOverflow - 1; i >= 0; i--) {
    const date = new Date(prevMonthYear, prevMonth, totalDaysPrevMonth - i);
    addDay(date, false);
  }

  // Add days of the current month
  const totalDaysCurrentMonth = lastDayOfMonth.getDate();
  for (let day = 1; day <= totalDaysCurrentMonth; day++) {
    const date = new Date(year, month, day);
    addDay(date, true);
  }

  // Add days from the next month
  const nextMonthYear = month === 11 ? year + 1 : year;
  const nextMonth = (month + 1) % 12;
  for (let i = 1; i <= nextMonthOverflow; i++) {
    const date = new Date(nextMonthYear, nextMonth, i);
    addDay(date, false);
  }

  return days;
}

const days = computed(() => generateCalendarDays(currentYear.value, currentMonth.value));

const isSelectedDate = (date) => {

  return selectedDate.value == date;
  // return true;
};

const goBackMonth = () => {
  currentMonth.value = currentMonth.value - 1;
};

const goForwardMonth = () => {
  currentMonth.value = currentMonth.value + 1;
};
const onMonthDateSelect = (date) => {

  selectedDate.value = date;
};
const toggle = (event) => {
    op.value.toggle(event);
}

const showTask = ref(false)
const showEditTask = ref(false)

// get selectedDate meetings
const selectedDateMeetings = computed(() => {
  return meetings.value.filter((meeting) => {
    return new Date(meeting.due_date).toDateString() === selectedDate.value.toDateString();
  });
});

const currentTask = ref(null)
function editTask(task) {
  currentTask.value = task
  showEditTask.value = true
  taskForm.name = task.name
  taskForm.due_date = moment(task.due_date).format('DD-MM-YYYY HH:mm')
  taskForm.description = task.description
  taskForm.notify = task.notify
  taskForm.notify_at = moment(task.notify_at).format('DD-MM-YYYY HH:mm')
  taskForm.lot_id = task.lot_id
}

function saveTask() {
  taskForm.post('/portal/taken/' + currentTask.value.id + '/edit', {
    preserveScroll: true,
    onSuccess: (response) => {
      taskForm.reset();
      showEditTask.value = false;
      //update the task in the meetings array
      meetings.value = response.props.auth.user.tasks

      currentTask.value = null;
    },
  })
}

function deleteTask(task) {
  axios.delete('/portal/taken/' + task.id + '/delete').then((response) => {
    //update the task in the meetings array
    meetings.value = response.data.tasks
  }).catch((error) => {
    console.log(error);
  });
}

const currentYear = ref(new Date().getFullYear())
const currentMonth = ref(new Date().getMonth())
const selectedDate = ref(new Date())
</script>

<template>
  <Head title="Dashboard | Mijnautosnelweg" />
  <img class="h-32 w-full object-cover lg:h-48" src="https://images.unsplash.com/photo-1444628838545-ac4016a5418a?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80" alt="" />
  <main class="px-4 sm:px-6 py-6 space-y-8">
    <div>
      <nav class="flex" aria-label="Breadcrumb">
        <ol role="list" class="flex items-center space-x-4">
          <li>
            <div class="flex">
              <Link href="/portal/dashboard" class="text-sm font-medium text-gray-500 hover:text-gray-700">Dashboard
              </Link>
            </div>
          </li>
        </ol>
      </nav>
    </div>
    <div class="md:flex md:items-center md:justify-between">
      <div class="min-w-0 flex-1">
        <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight"
          v-text="'Welkom ' + user.first_name"></h2>
        <p class="mt-1 truncate text-sm text-gray-500">Welkom op mijnautosnelweg.</p>
      </div>
    </div>
    <div>
      <h3 class="text-base font-semibold leading-6 text-gray-900">Recente activiteit</h3>
      <dl v-if="!user.dealer" class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:flex flex-row">
        <div v-for="item in statsAdmin" :key="item.id"
          class="relative lg:flex-1 overflow-hidden border rounded-lg bg-white px-4 pb-12 pt-5 shadow sm:px-6 sm:pt-6">
          <dt>
            <div class="absolute rounded-md bg-royalblue-500 px-3 pb-2 pt-3">
              <font-awesome-icon :icon="['far', item.icon]" class="text-white h-5 w-5 shrink-0"/>
            </div>
            <p class="ml-16 truncate text-sm font-medium text-gray-500">{{ item.name }}</p>
          </dt>
          <dd class="ml-16 flex items-center justify-between pb-6 sm:pb-7">
            <p class="text-2xl font-semibold text-gray-900">{{ item.value }}</p>
            <div class="absolute left-0 right-0 bottom-0 bg-gray-50 px-4 py-4 sm:px-6">
              <div class="text-sm">
                <Link :href="item.url" class="font-medium text-brightorange hover:text-brightorange/80">Alle
                bekijken<span class="sr-only"> {{ item.name }} stats</span></Link>
              </div>
            </div>
          </dd>
        </div>
      </dl>
      <dl v-if="user.dealer" class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:flex flex-row">
        <div v-for="item in statsDealer" :key="item.id"
          class="relative lg:flex-1 overflow-hidden border rounded-lg bg-white px-4 pb-12 pt-5 shadow sm:px-6 sm:pt-6">
          <dt>
            <div class="absolute rounded-md bg-royalblue-500 px-3 pb-2 pt-3">
              <font-awesome-icon :icon="['far', item.icon]" class="text-white h-5 w-5 shrink-0"/>
            </div>
            <p class="ml-16 truncate text-sm font-medium text-gray-500">{{ item.name }}</p>
          </dt>
          <dd class="ml-16 flex items-center justify-between pb-6 sm:pb-7">
            <p class="text-2xl font-semibold text-gray-900">{{ item.value }}</p>
            <div class="absolute left-0 right-0 bottom-0 bg-gray-50 px-4 py-4 sm:px-6">
              <div class="text-sm">
                <Link :href="item.url" class="font-medium text-brightorange hover:text-brightorange/80">Alle
                bekijken<span class="sr-only"> {{ item.name }} stats</span></Link>
              </div>
            </div>
          </dd>
        </div>
      </dl>
    </div>
    <div v-if="!user.dealer">
      <h2 class="text-base font-semibold leading-6 text-gray-900">Takenlijst</h2>
      <div class="flex flex-col w-full lg:flex-row gap-x-16">
        <div class="hidden w-1/2 max-w-md flex-none border-gray-100 py-10 lg:block">
          <div class="flex items-center text-center text-gray-900">
            <button @click="goBackMonth()" type="button"
              class="-m-1.5 flex flex-none items-center justify-center p-1.5 text-gray-300 hover:text-gray-500">
              <span class="sr-only">Vorige</span>
              <font-awesome-icon :icon="['far', 'chevron-left']" class="h-5 w-5 shrink-0"/>
            </button>
            <div class="flex-auto text-sm font-semibold">{{ formatMonth(currentMonth) }}</div>
            <button @click="goForwardMonth()" type="button"
              class="-m-1.5 flex flex-none items-center justify-center p-1.5 text-gray-300 hover:text-gray-500">
              <span class="sr-only">Volgende</span>
              <font-awesome-icon :icon="['far', 'chevron-right']" class="h-5 w-5 shrink-0"/>
            </button>
          </div>
          <div class="mt-6 grid grid-cols-7 text-center text-xs leading-6 text-gray-500">
            <div>M</div>
            <div>D</div>
            <div>W</div>
            <div>D</div>
            <div>V</div>
            <div>Z</div>
            <div>Z</div>
          </div>
          <div class="isolate mt-2 grid grid-cols-7 gap-px rounded-lg bg-gray-200 text-sm shadow ring-1 ring-gray-200">
            <button @click="onMonthDateSelect(day.date)" v-for="(day, dayIdx) in days" :key="day.date" type="button"
              :class="['py-1.5 hover:bg-gray-100 focus:z-10', day.isCurrentMonth ? 'bg-white' : 'bg-gray-50', (isSelectedDate(day.date) || day.isToday) && 'font-semibold', isSelectedDate(day.date) && 'text-white', !isSelectedDate(day.date) && day.isCurrentMonth && !day.isToday && 'text-gray-900', !isSelectedDate(day.date) && !day.isCurrentMonth && !day.isToday && 'text-gray-400', day.isToday && !isSelectedDate(day.date) && 'text-brightorange', dayIdx === 0 && 'rounded-tl-lg', dayIdx === 6 && 'rounded-tr-lg', dayIdx === days.length - 7 && 'rounded-bl-lg', dayIdx === days.length - 1 && 'rounded-br-lg']">
              <time :datetime="day.date"
                :class="['mx-auto flex h-7 w-7 items-center justify-center rounded-full', isSelectedDate(day.date) && day.isToday && 'bg-brightorange', isSelectedDate(day.date) && !day.isToday && 'bg-royalblue-500']">{{
                  day.dateKey.split('-')[0] }}</time>
            </button>
          </div>
        </div>
        <div class="w-full flex flex-col">
          <ol class="mt-4 text-sm leading-6 w-full">
            <li v-for="task in selectedDateMeetings" :key="task.id"
              class="relative flex flex-wrap space-x-6 py-4 xl:static border-b">
              <div class="flex-auto">
                <h3 class="pr-10 font-semibold text-gray-900 xl:pr-0">{{ task.name }}</h3>
                <dl class="mt-2 flex flex-col text-gray-500 xl:flex-row">
                  <div class="flex items-start space-x-3">
                    <dt class="mt-0.5">
                      <span class="sr-only">Datum</span>
                      <font-awesome-icon :icon="['far', 'calendar']" class="text-gray-400 h-5 w-5 shrink-0"/>
                    </dt>
                    <dd>
                      {{moment(task.due_date).format('DD-MM-YYYY HH:mm')}}
                    </dd>
                  </div>
                </dl>
                <div class="mt-2 text-sm">{{ task.description }}</div>
                <div class="mt-2 text-sm" v-if="task.lot_id">Taak gekoppeld aan kavel: <Link class="text-royalblue-500 hover:text-royalblue-500/80 hover:underline" :href="'/portal/kavel/'+task.lot_id">{{ task.lot_id }}</Link> </div>
              </div>
              <div class="flex flex-row gap-2 sm:gap-4">
                <Link :href="'/portal/taken/' + task.id + '/complete'" preserve-scroll>
                  <font-awesome-icon :icon="['fal', 'check']" class="shrink-0 hover:cursor-pointer h-5 w-5 p-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 rounded-lg"/>
                </Link>
                <font-awesome-icon @click="editTask(task)" :icon="['fal', 'pencil']" class="shrink-0 hover:cursor-pointer h-5 w-5 p-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 rounded-lg"/>
                <font-awesome-icon label="Delete" severity="danger" @click="deleteTask(task)" :icon="['fal', 'trash-can']" class="shrink-0 hover:cursor-pointer h-5 w-5 p-2.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 rounded-lg"/>
              </div>
            </li>
          </ol>
          <div class="pt-4 flex gap-6 items-center">
            <button @click="showTask = true; taskForm.reset(); taskForm.user_id = user.id" type="button"
              class="w-auto rounded-md bg-royalblue-500 p-2 text-sm font-semibold text-white shadow-sm hover:bg-royalblue-500/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500">
              Taak toevoegen
            </button>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div v-if="user.dealer" class="flex flex-col sm:flex-row">
        <div class="flex flex-col w-full">
          <h1 class="text-base font-semibold leading-6 text-gray-900">Interessant voor jou</h1>
          <p class="mt-2 text-sm text-gray-700">Je hebt jouw voorkeuren ingesteld op <strong
              class="font-semibold text-gray-900">jong & fris</strong>. <br class="md:hidden">Bekijk het nieuwste aanbod
            in deze categorie</p>
        </div>
        <div class="sm:ml-16 mt-4 sm:mt-0 flex-none">
          <Link href="/portal/settings" type="button"
            class="w-auto rounded-md bg-royalblue-500 px-3 py-2 text-sm font-semibold text-nowrap text-white shadow-sm hover:bg-royalblue-500/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500">
          Voorkeuren aanpassen
          </Link>
        </div>
      </div>
      <div v-if="!user.dealer" class="flex flex-col w-full">
        <h1 class="text-base font-semibold leading-6 text-gray-900">Nieuwste aanbod</h1>
      </div>
      <div>
        <div class="mt-10 ring-1 ring-gray-300 rounded-lg w-full">
          <table class="min-w-full divide-y divide-gray-300 border-b">
            <thead>
              <tr>
                <th scope="col"
                  class="hidden sm:table-cell px-3 py-3.5 flex-1 text-left text-sm font-semibold text-gray-900">
                  Kavelnummer
                </th>
                <th scope="col" class="px-3 py-3.5 flex-1 text-left text-sm font-semibold text-gray-900">
                  Merk &
                  model</th>
                <th scope="col" class="px-3 py-3.5 flex-1 text-left text-sm font-semibold text-gray-900">
                  KM-stand
                </th>
                <th scope="col"
                  class="hidden md:table-cell px-3 py-3.5 flex-1 text-left text-sm font-semibold text-gray-900">
                  Bouwjaar
                </th>
                <th scope="col"
                  class="hidden lg:table-cell px-3 py-3.5 flex-1 text-left text-sm font-semibold text-gray-900">
                  Transmissie
                </th>
                <th scope="col"
                  class="hidden lg:table-cell px-3 py-3.5 flex-1 text-left text-sm font-semibold text-gray-900">
                  Brandstof
                </th>
                <th scope="col"
                  class="hidden lg:table-cell px-3 py-3.5 flex-1 text-left text-sm font-semibold text-gray-900">
                  Prijsindicatie
                </th>
                <th scope="col"
                  class="hidden lg:table-cell px-3 py-3.5 flex-1 text-left text-sm font-semibold text-gray-900">
                  Hoogste bod
                </th>
              </tr>
            </thead>
            <tbody class="divide-y">
              <tr v-for="lot in props.newLots">
                <td
                  class="hidden sm:table-cell whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-3">
                  {{
                    lot.id }}
                </td>
                <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 max-w-1 overflow-clip overflow-ellipsis">{{
                  lot.make }} {{ lot.model
                  }}
                  {{ lot.body_type ?? '' }}
                </td>
                <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{ formatMileage(lot.mileage) }} km
                </td>
                <td class="hidden md:table-cell whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                  lot.construction_year }}
                </td>
                <td class="hidden lg:table-cell whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                  lot.transmission }}</td>
                <td class="hidden lg:table-cell whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                  lot.fuel_type }}</td>
                <td class="hidden lg:table-cell whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                  eurFormatter.format(lot.price_indication) }}</td>
                <td class="hidden lg:table-cell whitespace-nowrap px-3 py-4 text-sm text-gray-500">{{
                  eurFormatter.format(lot.highest_bid) }}</td>
                <td class="absolute right-8 whitespace-nowrap py-4 text-right text-sm font-medium">
                  <Link :href="'/portal/kavel/' + lot.id" class="hidden lg:table-cell text-brightorange hover:text-brightorange/80">
                  Bekijk
                  </Link>
                  <Link :href="'/portal/kavel/' + lot.id" class="table-cell lg:hidden text-brightorange hover:text-brightorange/80">
                  <font-awesome-icon :icon="['far', 'eye']" class="h-5 w-5 shrink-0"/>
                  </Link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </main>

  <TransitionRoot as="template" :show="showTask">
    <Dialog as="div" class="relative z-50" @close="showTask = false">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
        leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed left-0 right-0 top-0 bottom-0 bg-black bg-opacity-50 transition-opacity" @click="showTask = false" />
      </TransitionChild>

      <div class="fixed left-0 right-0 top-0 bottom-0 z-[100] w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel
              class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:p-6">
              <div class="flex flex-col gap-4 p-4">
                <div class="flex justify-between items-center pb-4 mb-4 rounded-t border-b sm:mb-5 ">
                  <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900">Maak een nieuwe taak aan
                  </DialogTitle>
                  <button type="button"
                    class="text-gray-900 hover:text-royalblue-500 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                    @click="showTask = false">
                    <font-awesome-icon :icon="['far', 'xmark']" class="h-5 w-5 shrink-0"/>
                    <span class="sr-only">Close modal</span>
                  </button>
                </div>
                <div class=" w-full flex flex-col gap-y-2">
                    <label for="category" class="block text-sm font-medium text-gray-900">Taak titel</label>
                    <input type="text" class="input-style" v-model="taskForm.name" />
                    <div class="text-red-500" v-if="taskForm.errors.name">{{ taskForm.errors.name }}</div>
                </div>
                <div class=" w-full flex flex-col gap-y-2 gap-x-3">
                    <label for="category" class="block text-sm font-medium text-gray-900">Taak beschrijving</label>
                    <textarea class="textarea-style" v-model="taskForm.description" />
                    <div class="text-red-500" v-if="taskForm.errors.description">{{ taskForm.errors.description }}</div>
                </div>
                <div class=" w-full flex flex-col gap-y-2 gap-x-3">
                  <label for="category" class="block text-sm font-medium text-gray-900">Datum en
                    tijd</label>
                  <div class="flex flex-row gap-y-2 gap-x-3">
                    <Calendar v-model="taskForm.due_date" showTime dateFormat="dd-mm-yy" class="w-full" />
                  </div>
                  <div class="text-red-500" v-if="taskForm.errors.due_date">{{ taskForm.errors.due_date }}</div>
                </div>
                <div class=" w-full flex flex-col gap-y-2 gap-x-3">
                  <label for="category" class="block text-sm font-medium text-gray-900">Kavel</label>
                  <div class="flex flex-row gap-y-2 gap-x-3">
                    <Dropdown v-model="taskForm.lot_id" class="dropdown-style" filter :options="props.lots" optionValue="id" optionLabel="id"/>
                  </div>
                  <div class="text-red-500" v-if="taskForm.errors.lot_id">{{ taskForm.errors.lot_id }}</div>
                </div>
                <div class=" w-full flex flex-col gap-y-2 gap-x-3">
                  <label for="category" class="block text-sm font-medium text-gray-900">Gebruiker</label>
                  <div class="flex flex-row gap-y-2 gap-x-3">
                    <Dropdown v-model="taskForm.user_id" class="dropdown-style" filter :options="props.users" optionValue="id" optionLabel="full_name"/>
                  </div>
                  <div class="text-red-500" v-if="taskForm.errors.lot_id">{{ taskForm.errors.lot_id }}</div>
                </div>
                <div class=" w-full flex flex-col gap-y-2 gap-x-3">
                  <label for="category" class="block text-sm font-medium text-gray-900">Stuur notificatie</label>
                  <div class="flex flex-row gap-y-2 gap-x-3">
                    <Switch v-model="taskForm.notify" as="template" v-slot="{ checked }">
                      <button
                        class="relative inline-flex h-6 w-11 items-center rounded-full"
                        :class="checked ? 'bg-royalblue-500' : 'bg-gray-200'"
                      >
                        <span class="sr-only">Notificaties aan</span>
                        <span
                          :class="checked ? 'translate-x-6' : 'translate-x-1'"
                          class="inline-block h-4 w-4 transform rounded-full bg-white transition"
                        />
                      </button>
                    </Switch>
                  </div>
                  <div class="text-red-500" v-if="taskForm.errors.notify">{{ taskForm.errors.notify }}</div>
                </div>
                <div class=" w-full flex flex-col gap-y-2 gap-x-3" v-if="taskForm.notify">
                  <label for="category" class="block text-sm font-medium text-gray-900">Datum en tijd voor notificatie</label>
                  <div class="flex flex-row gap-y-2 gap-x-3">
                    <Calendar v-model="taskForm.notify_at" showTime dateFormat="dd-mm-yy" class="w-full" />
                  </div>
                  <div class="text-red-500" v-if="taskForm.errors.notify_at">{{ taskForm.errors.notify_at }}</div>
                </div>
                <div class="sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                  <button type="button"
                    class="inline-flex w-full justify-center rounded-md bg-brightorange px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-brightorange/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500 sm:col-start-2"
                    @click="storeTask">Taak opslaan</button>
                  <button type="button"
                    class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                    @click="showTask = false" ref="cancelButtonRef">Annuleer</button>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>

  <TransitionRoot as="template" :show="showEditTask">
    <Dialog as="div" class="relative z-50" @close="showEditTask = false">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
        leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed left-0 right-0 top-0 bottom-0 bg-black bg-opacity-50 transition-opacity" @click="showEditTask = false" />
      </TransitionChild>

      <div class="fixed left-0 right-0 top-0 bottom-0 z-[100] w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel
              class="relative transform overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl sm:p-6">
              <div class="flex flex-col gap-4 p-4">
                <div class="flex justify-between items-center pb-4 mb-4 rounded-t border-b sm:mb-5 ">
                  <DialogTitle as="h3" class="text-base font-semibold leading-6 text-gray-900">Taak aanpassen
                  </DialogTitle>
                  <button type="button"
                    class="text-gray-900 hover:text-royalblue-500 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
                    @click="showEditTask = false">
                    <font-awesome-icon :icon="['far', 'xmark']" class="h-5 w-5 shrink-0"/>
                    <span class="sr-only">Close modal</span>
                  </button>
                </div>
                <div class=" w-full flex flex-col gap-y-2">
                    <label for="category" class="block text-sm font-medium text-gray-900">Taak titel</label>
                    <input type="text" class="input-style" v-model="taskForm.name" />
                    <div class="text-red-500" v-if="taskForm.errors.name">{{ taskForm.errors.name }}</div>
                </div>
                <div class=" w-full flex flex-col gap-y-2 gap-x-3">
                    <label for="category" class="block text-sm font-medium text-gray-900">Taak beschrijving</label>
                    <textarea class="textarea-style" v-model="taskForm.description" />
                    <div class="text-red-500" v-if="taskForm.errors.description">{{ taskForm.errors.description }}</div>
                </div>
                <div class=" w-full flex flex-col gap-y-2 gap-x-3">
                  <label for="category" class="block text-sm font-medium text-gray-900">Datum en
                    tijd</label>
                  <div class="flex flex-row gap-y-2 gap-x-3">
                    <Calendar v-model="taskForm.due_date" showTime dateFormat="dd-mm-yy" class="w-full" />
                  </div>
                  <div class="text-red-500" v-if="taskForm.errors.due_date">{{ taskForm.errors.due_date }}</div>
                </div>
                
                <div class=" w-full flex flex-col gap-y-2 gap-x-3">
                  <label for="category" class="block text-sm font-medium text-gray-900">Kavel</label>
                  <div class="flex flex-row gap-y-2 gap-x-3">
                    <Dropdown v-model="taskForm.lot_id" class="dropdown-style" filter :options="props.lots" optionValue="id" optionLabel="id"/>
                  </div>
                  <div class="text-red-500" v-if="taskForm.errors.lot_id">{{ taskForm.errors.lot_id }}</div>
                </div>
                <div class=" w-full flex flex-col gap-y-2 gap-x-3">
                  <label for="category" class="block text-sm font-medium text-gray-900">Stuur notificatie</label>
                  <div class="flex flex-row gap-y-2 gap-x-3">
                    <Switch v-model="taskForm.notify" as="template" v-slot="{ checked }">
                      <button
                        class="relative inline-flex h-6 w-11 items-center rounded-full"
                        :class="checked ? 'bg-royalblue-500' : 'bg-gray-200'"
                      >
                        <span class="sr-only">Notificaties aan</span>
                        <span
                          :class="checked ? 'translate-x-6' : 'translate-x-1'"
                          class="inline-block h-4 w-4 transform rounded-full bg-white transition"
                        />
                      </button>
                    </Switch>
                  </div>
                  <div class="text-red-500" v-if="taskForm.errors.notify">{{ taskForm.errors.notify }}</div>
                </div>
                <div class=" w-full flex flex-col gap-y-2 gap-x-3" v-if="taskForm.notify">
                  <label for="category" class="block text-sm font-medium text-gray-900">Datum en tijd voor notificatie</label>
                  <div class="flex flex-row gap-y-2 gap-x-3">
                    <Calendar v-model="taskForm.notify_at" showTime dateFormat="dd-mm-yy" class="w-full" />
                  </div>
                  <div class="text-red-500" v-if="taskForm.errors.notify_at">{{ taskForm.errors.notify_at }}</div>
                </div>
                <div class="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                  <button type="button"
                    class="inline-flex w-full justify-center rounded-md bg-brightorange px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-brightorange/80 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue-500 sm:col-start-2"
                    @click="saveTask">Taak opslaan</button>
                  <button type="button"
                    class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:col-start-1 sm:mt-0"
                    @click="showEditTask = false" ref="cancelButtonRef">Annuleer</button>
                </div>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
